import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
@Pipe({
  name: 'formateDate'
})
export class FormateDatePipe implements PipeTransform {

//  private readonly timezoneMap: Record<string, string> = {
//     EST: 'America/New_York',
//     CST: 'America/Chicago',
//     MST: 'America/Denver',
//     PST: 'America/Los_Angeles',
//     AKT: 'America/Anchorage',
//     HST: 'Pacific/Honolulu',
//     UTC: 'UTC',
//     GMT: 'Etc/GMT',
//     WET: 'Europe/Lisbon',
//     IST: 'Europe/Dublin',
//     CET: 'Europe/Berlin',
//     EET: 'Europe/Athens',
//     MSK: 'Europe/Moscow',
//     AMT: 'Asia/Yerevan',
//     AZT: 'Asia/Baku',
//     GET: 'Asia/Tbilisi',
//     AQTT: 'Asia/Aqtobe',
//     PKT: 'Asia/Karachi',
//     ACT: 'Australia/Adelaide',
//     AET: 'Australia/Sydney'
//   };
// transform(value: any, backendTimezone?: string): string | null {
//  if (!value) return null;

//   value = value.toString();
//   const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
//   if (!isoDateRegex.test(value)) return value;

//   // 🕒 Parse without applying any timezone (just format as-is)
//   const dt = DateTime.fromISO(value);
//   if (!dt.isValid) return value;

//   // 📌 Format date
//   const formatted = dt.toFormat('MM/dd/yyyy hh:mm a');

//   // 🏷️ Add timezone label (fallback to UTC if not provided)
//   const label = backendTimezone || 'UTC';
//   return `${formatted} ${label}`;
// }

private readonly timezoneMap: Record<string, string> = {
    EST: 'America/New_York',
    EDT: 'America/New_York',
    CST: 'America/Chicago',
    CDT: 'America/Chicago',
    MST: 'America/Denver',
    MDT: 'America/Denver',
    PST: 'America/Los_Angeles',
    PDT: 'America/Los_Angeles',
    AKT: 'America/Anchorage',
    HST: 'Pacific/Honolulu',
    UTC: 'UTC',
    GMT: 'Etc/GMT',
    WET: 'Europe/Lisbon',
    IST: 'Europe/Dublin',
    CET: 'Europe/Berlin',
    EET: 'Europe/Athens',
    MSK: 'Europe/Moscow',
    AMT: 'Asia/Yerevan',
    AZT: 'Asia/Baku',
    GET: 'Asia/Tbilisi',
    AQTT: 'Asia/Aqtobe',
    PKT: 'Asia/Karachi',
    ACT: 'Australia/Adelaide',
    AET: 'Australia/Sydney'
  };
  transform(
    value: any,
    userTimezone?: string | undefined | null,
    elementTimezone?: string | undefined | null,
  ): string | null {
    if (!value) return null;
    value = value.toString();
    // ✅ Skip non-date strings like "12", "abc", etc.
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/; // Basic ISO check
    if (!isoDateRegex.test(value)) {
      return value; // ⛔ not a date, just return as-is
    }
    // Step 1: Get the backend's IANA timezone
    const backendZone = this.timezoneMap[elementTimezone || ''] || elementTimezone || 'UTC';
    let dt: DateTime;

    if (userTimezone) {
      const userSelectedTimeZone = this.timezoneMap[userTimezone];

      // Step 1: Interpret value in backend timezone
      const backendTime = DateTime.fromISO(value).setZone(backendZone, { keepLocalTime: true });

      // Step 2: Convert to user-selected timezone (time adjust hoga)
      dt = backendTime.setZone(userSelectedTimeZone, { keepLocalTime: false });
    } else {
      // Step 1 (only): Just tag the value with backend zone, no conversion
      dt = DateTime.fromISO(value).setZone(backendZone, { keepLocalTime: true });
    }
    // 🕒 Format
    return dt.toFormat('MM/dd/yyyy hh:mm a ZZZZ');
  }


}
